/* Formatting + date helpers shared across every screen. */

import { COLORS } from "../theme.js";

export function fmtMoney(n) {
  return `$${Number(n || 0).toLocaleString()}`;
}

export function fmtDate(d) {
  if (!d) return "—";
  const dt = new Date(d);
  return dt.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function fmtDateShort(d) {
  if (!d) return "—";
  const dt = new Date(d);
  return dt.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}

export function daysSince(d) {
  if (!d) return Infinity;
  return Math.floor((Date.now() - new Date(d).getTime()) / 86400000);
}

export function addDays(d, n) {
  const dt = d ? new Date(d) : new Date();
  dt.setDate(dt.getDate() + n);
  return dt;
}

export function daysBetween(a, b) {
  if (!a || !b) return null;
  return Math.round((new Date(b) - new Date(a)) / 86400000);
}

export function fmtDuration(days) {
  if (days == null) return "—";
  if (days < 0) return "in the future";
  if (days < 30) return `${days}d`;
  if (days < 365) return `${Math.round(days / 30)}mo`;
  const y = Math.floor(days / 365);
  const m = Math.round((days % 365) / 30);
  return m > 0 ? `${y}y ${m}mo` : `${y}y`;
}

/** Today as an ISO date string (YYYY-MM-DD) — the storage format for all `date` columns. */
export function today() {
  return new Date().toISOString().slice(0, 10);
}

/** Accepts a Date or an ISO string and returns YYYY-MM-DD. */
export function toISODate(d) {
  if (!d) return null;
  return d instanceof Date ? d.toISOString().slice(0, 10) : String(d).slice(0, 10);
}

export function conditionColor(v) {
  if (v >= 90) return COLORS.green;
  if (v >= 70) return COLORS.goldBright;
  return COLORS.red;
}
